import Analytics from './Analytics';
import BrainbayLogo from './Brainbay';
import Browser from './Browser';
import DatHuisLogo from './DatHuis';
import FundaLogo from './Funda';
import ZapierLogo from './Zapier';
import RealworksLogo from './Realworks';
import Hypotheekbond from './Hypotheekbond';
import AvixLogo from './Avix';
import AvixEmblem from './AvixEmblem';
import ARXGroepLogo from './ARXGroepLogo';
import ARXGroepEmblem from './ARXGroepEmblem';
import Trustoo from './Trustoo';
import TrustooEmblem from './TrustooEmblem';
import Enven from './Enven';
import Duurzaamheidsprofiel from './Duurzaamheidsprofiel';

export type Props = React.SVGAttributes<SVGElement> & {
  color?: string;
  secondary?: boolean;
};

const logos = {
  brainbay: BrainbayLogo,
  funda: FundaLogo,
  dathuis: DatHuisLogo,
  avix: AvixLogo,
  avixEmblem: AvixEmblem,
  enven: Enven,
  browser: Browser,
  analytics: Analytics,
  zapier: ZapierLogo,
  realworks: RealworksLogo,
  hypotheekbond: Hypotheekbond,
  arxGroep: ARXGroepLogo,
  arxGroepEmblem: ARXGroepEmblem,
  trustoo: Trustoo,
  trustooEmblem: TrustooEmblem,
  susReport: Duurzaamheidsprofiel,
};

export default logos;
